import { IReportSourceBackend } from "./report";
import { ILabel } from "./label";

export interface ISnippetBackend {
  id: number | null;
  report_name: string;
  report_url: string;
  source: string | IReportSourceBackend;
  text: string;
  labels?: ILabel[];
}

export interface ISnippet {
  id: number | null;
  reportName: string;
  reportUrl: string;
  source: ISnippetSource;
  text: string;
  labels: ILabel[];
}

export interface ISnippetSource {
  id: number | null;
  category: string;
  logo: string;
  name: string;
  url: string;
}

export const createSnippetSource = (
  source: string | IReportSourceBackend
): ISnippetSource => {
  if (typeof source === "string")
    return Object.freeze({
      id: null,
      name: source,
      category: "",
      logo: "",
      url: "",
    });
  return Object.freeze({
    id: null,
    name: source.name,
    category: source.category,
    logo: source.logo,
    url: source.domain,
  });
};

export const createSnippet = (snippet: ISnippetBackend): ISnippet => {
  return Object.freeze({
    id: snippet.id,
    reportName: snippet.report_name,
    reportUrl: snippet.report_url,
    source: createSnippetSource(snippet.source),
    text: snippet.text,
    labels: snippet.labels || [],
  });
};

// export const createSnippets = (snippets: ISnippetBackend][]): ISnippet => {
//   return Object.freeze({
//     id: snippet.id,
//     reportName: snippet.report_name,
//     reportUrl: snippet.report_url,
//     source: createSnippetSource(snippet.source),
//     text: snippet.text,
//   });
// };

export const createSnippetBackend = (snippet: ISnippet): ISnippetBackend => {
  return Object.freeze({
    id: null,
    report_name: snippet.reportName,
    text: snippet.text,
    source: snippet.source.name,
    report_url: snippet.source.url,
  });
};
